import { Inject, Injectable } from '@angular/core';
import {HttpClient} from '@angular/common/http';

@Injectable({ providedIn: 'root'})
export class ReviewInstanceService {

  constructor(private http: HttpClient,
              @Inject('BASE_URL') private baseUrl: string) { }

  getReviewableInstances(reviewFilter) {
    return this.http.post<any>('api/review/getReviewableInstances', reviewFilter);
  }

  getInstanceReview(instanceReviewId: number) {
    return this.http.get<any>(`api/review/getInstanceReview/${instanceReviewId}`);
  }
}

